const isAuthenticated = state => state.user
const isAdmin = state => state.user && state.user.role.toLowerCase() == 'admin' ? true : false

export default {
    isAuthenticated,
    isAdmin
}
